export default __webpack_public_path__ + "static/img-tarjeta-tropicalized-7b7d8f6fb40e36c4ec6ca0db87589df0.png";